import { render, staticRenderFns } from "./detailProject.vue?vue&type=template&id=60a705cf&scoped=true"
import script from "./detailProject.vue?vue&type=script&lang=js"
export * from "./detailProject.vue?vue&type=script&lang=js"
import style0 from "./detailProject.vue?vue&type=style&index=0&id=60a705cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a705cf",
  null
  
)

export default component.exports